import React, {  useContext } from 'react'
import { Button, Modal, Icon } from 'semantic-ui-react'
import { fontsize } from '../../helpers';
import { Text } from '../../helpers/language';

const ModalDialog = (props) => {

  const {header, body, type, positiveButtonText, negativeButtonText, onCancel, onOk } = props;

  return (

    <Modal size='tiny' open={header != null || body != null} >
      <Modal.Header className='text-center' style={{fontSize: '28px'}}>       
          {type === 'error' && <>
              <Icon color='red' size='large' name='warning circle' />
              <Text tid='error' />
            </>} 
          {type === 'warning' && <>
            <Icon color='orange' size='large' name='warning sign' />
            <Text tid='something_is_wrong' />
            </>
            } 
          {type === 'info' && <> 
              <Icon color='green' size='large' name='info circle' />
              <Text tid='all_ok' />
            </>
          }         
      </Modal.Header>   
      <Modal.Content className='text-center'>
        <div style={{fontSize: '24px', fontStyle: 'bold', margin: '5px'}}>
        {header}
        </div>
        <Modal.Description style={{fontSize: '18px'}}>
            {body}
        </Modal.Description>
      </Modal.Content>  
      <Modal.Actions>
          <Button 
            className='lisia-button'
            negative             
            onClick={() => onCancel()}
          >
            {negativeButtonText}           
          </Button>
          <Button 
            className='lisia-button lisia-blue'
            onClick={() => onOk()}
          >
            {positiveButtonText}            
          </Button>
       </Modal.Actions>       
    </Modal>
    )
}

export default ModalDialog
